import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import GDTableSummaryRow from 'Components/GDTable/GDTableSummaryRow';
import GDFilterPane from 'Components/GDReportRunner/GDFilterPane/GDFilterPane';
import { connect } from 'react-redux';
import './CaseSelection.scss';
import ManualTransaction from 'Containers/ManualTransaction/ManualTransaction';
import { postFilterValues } from 'Apis/referenceDataApi.js';
import { fetchMultipleMatchTransactionByCaseNumber, getAllUnmatchedCases, postLockCase, unlockCase } from 'Apis/caseDataAPI.js';
import {
  setLockedCaseCount,
  getLockedCaseCount,
  setLockedCases,
  removeLockedCases,
  checkCaseIsPresent,
} from 'Utils/localStorageUtils.js';
import GDTableSummaryPanel from 'Components/GDTable/GDTableSummaryPanel';
import GDTableSummaryHorizontalPanel from 'Components/GDTable/GDTableSummaryHorizontalPanel';
import ComboButton from 'Components/Button/ComboButton';
import ResponseBanner from 'Components/cards/ResponseBanner';
import { addNewTransaction } from 'Apis/transactionApi.js';
import { getFormMetaData } from 'Containers/ManualTransaction/configureForm';
import counterpart from 'counterpart';
import moment from 'moment';
import { addCaseToRecent } from 'Actions/recentCasesAction.js';
import { getMetaData, getTranslations, getValidations } from 'Containers/QueueLanding/configStructure';
import { getToken } from 'Apis/tokenizeFilterElement';
import EmptyState from 'Components/EmptyState/EmptyState';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { getCaseStageId } from 'Utils/localStorageUtils.js';
import UserLockIcon from 'Components/icons/UserLockIcon.jsx';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import { isUserAuthenticatedSelector } from 'Selectors';
import { deleteNonDimsCase } from 'Apis/dimsCaseValidatorApi.js';
import { addManualTransactionNotificationBanner, dangerNotificationBanner, closeNotificationBanner } from 'Actions/notificationAction';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { getCurrencyBasedOnElementIdWithAcquirer } from '../../api/caseDataAPI';

const _AMEX_QUEUE_ = 71;
import { VITE_TRANSACTION_UNMATCHED_QUEUE } from 'Constants/appEnvConstants';
import { AMEX_QUEUE } from 'Constants/caseDetailConstants';

import ImagePortal from '../ImagePortal/ImagePortal';

const structureMetaData = getFormMetaData();

let visibilityProps;

export class CaseSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAddTransactionManual: false,
      showManualSearch: false,
      value: '',
      isError: false,
      errorMessage: '',
      scrollPos: 0,
      openBanner: false,
      targetDone: false,
      createdCaseNumber: '',
      currentValues: {},
      isMinField: true,
      bannerDescription: '',
      suggestedTransError: false,
      caseDataErr: false,
      isReadOnly: false,
      filters: [],
      structureMetaData : getFormMetaData()
    };
    this.attachBindings();
  }

  componentWillMount() {
    const caseStageId = getCaseStageId();
    this.getAllCasesData(this.props.match.params.queueId, 0, 25, getMetaData(this.props.match.params.queueId).defaultSort, undefined, undefined, this.props.match.params.caseNumber, caseStageId);
    visibilityProps = getMetaData(this.props.match.params.queueId);
    this.props.addCaseToRecentAction(this.props.match.params.caseNumber);
  }

  componentDidMount() {
    if (this.props.match.params.queueId == VITE_TRANSACTION_UNMATCHED_QUEUE) {
      this.fetchMultipleMatchTransactionByCaseNumber(this.props.match.params.caseNumber);
      this.getMerchantPaymentCurrency();
    }
    this.addFilterValidations();
    window.addEventListener('beforeunload', this.removeCurrentLockedCase);
  }
  componentWillUnmount() {
    window.addEventListener('beforeunload', this.removeCurrentLockedCase);

    const caseStageId = getCaseStageId();
    if (this.props.isUserAuthenticated
      && this.props.match.params.queueId == VITE_TRANSACTION_UNMATCHED_QUEUE
      && !this.state.isReadOnly
      && !checkCaseIsPresent(this.props.match.params.caseNumber, caseStageId)) {
      this.unlockCurrentCase();
    }
  }
  attachBindings() {
    this.toggleTransactionManual = this.toggleTransactionManual.bind(this);
    this.renderTransactionComponent = this.renderTransactionComponent.bind(this);
    this.openManualSearch = this.openManualSearch.bind(this);
    this.renderHorizontalTransactionSummaryPanel = this.renderHorizontalTransactionSummaryPanel.bind(this);
    this.onClickPrimaryActionButton = this.onClickPrimaryActionButton.bind(this);
    this.getTransactionDetails = this.getTransactionDetails.bind(this);
    this.showErrorBanner = this.showErrorBanner.bind(this);
    this.handleTakeActionClick = this.handleTakeActionClick.bind(this);
    this.closeBanner = this.closeBanner.bind(this);
    this.closeFilterPane = this.closeFilterPane.bind(this);
    this.toggleFilterPane = this.toggleFilterPane.bind(this);
    this.handleApplyFilters = this.handleApplyFilters.bind(this);
    this.resetFilterValues = this.resetFilterValues.bind(this);
    this.fetchMultipleMatchTransactionByCaseNumber = this.fetchMultipleMatchTransactionByCaseNumber.bind(this);
    this.getTokenFromCardNumber = this.getTokenFromCardNumber.bind(this);
    this.postApplyFilterValues = this.postApplyFilterValues.bind(this);
    this.getAllCasesData = this.getAllCasesData.bind(this);
    this.prepopulateFilterValues = this.prepopulateFilterValues.bind(this);
    this.onReadOnly = this.onReadOnly.bind(this);
    this.unlockCurrentCase = this.unlockCurrentCase.bind(this);
    this.removeCurrentLockedCase = this.removeCurrentLockedCase.bind(this);
    this.deleteCase = this.deleteCase.bind(this);
    this.addFilterValidations = this.addFilterValidations.bind(this);
    this.redirectToQueueLanding = this.redirectToQueueLanding.bind(this);
    this.getMerchantPaymentCurrency = this.getMerchantPaymentCurrency.bind(this);
  }

  goBack = () => {
   this.props.history.goBack();
   if(this.props.location.state == undefined){
    this.props.history.push({
      pathname:`/queue/${this.props.match.params.queueId}`,
    })
  }
  };
  resetScrollPos() {
    this.setState({
      scrollPos: 0,
    });
  }

  handleApplyFilters(newValues) {
    this.setState({ currentValues: newValues });
    this.closeFilterPane();
    let resultString = '';
    let isAccountRkNumber = false;
    let checkBothAccountFields = 0;
    let isAccountNumber = false;
    let checkAccountNumber = '';
    let isTransDatePresent = 0;
    const filterList = visibilityProps.caseSelectionConfig.searchFilters;
    let newFilterValues = Object.keys(newValues).map((key) => {
      return Object.assign({}, newValues[key], { id: key });
    });
    const dateFilter = filterList.filter((filter) => {
      return filter.elementMandatory === true;
    });

    let tempFilterValues = Object.assign([], newFilterValues);

    newFilterValues.forEach((filterValue) => {
      let updateIndex = tempFilterValues.findIndex(val => val.id == filterValue.id);
      for (const field in filterValue) {
        if (field == 'transactionDate') {
          isTransDatePresent++;
        }   
        else if((filterValue[field] == 'transactionAmount' || filterValue[field] == 'cardNumber') && field !== "id"){
          if(!(filterValue[field].v1  && filterValue[field].v2) && updateIndex !== -1) {
            tempFilterValues.splice(updateIndex, 1);
          }
        }
        else if(!filterValue[field].v1 && updateIndex !== -1 && field !== "id") {
          tempFilterValues.splice(updateIndex, 1);

        }
      }  
    });
    newFilterValues = Object.assign([],tempFilterValues);

    if (isTransDatePresent < 1) {
          
      const yesterDay = moment().subtract(1, 'days');
      const newDate = moment(yesterDay).subtract(3, 'months');

      const fromDate = moment(newDate).format(visibilityProps.caseSelectionConfig.page.dateFormat);
      const endDate = moment(yesterDay).format(visibilityProps.caseSelectionConfig.page.dateFormat);

      const currentValuesObj = dateFilter.reduce((obj, value) => {
          return Object.assign(obj, {
              [value.reportFilterId]:
                {
                  type: "BETWEEN",
                  v1: fromDate,
                  v2: endDate,
                  error: "",
                  flag: false,
                  id: value.reportFilterId,
                }
          });
        }, {});
        newFilterValues.push(currentValuesObj);
    }
    let minFieldLength = newFilterValues.length;
    /* const newActiveFilters = this.mapActiveFilters(
      newFilterValues,
      this.state.filters,
    ); */

    if (isAccountRkNumber && isAccountNumber) {
      checkBothAccountFields--;
      minFieldLength--;
    }
    if(minFieldLength < 2){
      this.setState({
        isMinField: false,
        bannerDescription: `At least 1 Field is required other than ${dateFilter[0].name} for the search.`,
      })
    }
    else if (minFieldLength === 0) {
      this.setState({
        isMinField: false,
        bannerDescription: `Atleast one field is required for search`,
      })
    }
    else {
      this.setState({
        isMinField: true,
      });
      newFilterValues.forEach((filterValue) => {
      for (const field in filterValue) {
        if (filterValue[field].v1) {
          if (field === 'transactionDate') {
            const isPresetFilter = [
              'yesterday',
              'last_seven_days',
              'this_month',
              'last_month',
              'this_year',
            ].includes(filterValue[field].v1);
            if(!isPresetFilter){
              filterValue[field].v1 = moment(filterValue[field].v1).format('YYYY-MM-DD');
              filterValue[field].v2 = moment(filterValue[field].v2).format('YYYY-MM-DD');
            }
            filterValue[field].v1 !== '' && filterValue[field].v1 !== undefined ? resultString = `${resultString}fromTransactionDate=${filterValue[field].v1}&` : '';
            filterValue[field].v2 !== '' && filterValue[field].v2 !== undefined ? resultString = `${resultString}toTransactionDate=${filterValue[field].v2}&` : '';
            checkBothAccountFields++;
            if(!isPresetFilter) {
              filterValue[field].v1 = moment(filterValue[field].v1).format(visibilityProps.caseSelectionConfig.page.dateFormat);
              filterValue[field].v2 = moment(filterValue[field].v2).format(visibilityProps.caseSelectionConfig.page.dateFormat);
            }
          }
          else if (field === 'cardNumberRk') {
            isAccountRkNumber = true;
            filterValue[field].v1 !== '' && filterValue[field].v1 !== undefined ? resultString = `${resultString}firstSixcardNumber=${filterValue[field].v1}&` : '';
            filterValue[field].v2 !== '' && filterValue[field].v2 !== undefined ? resultString = `${resultString}lastFourCardNumber=${filterValue[field].v2}&` : '';
            checkBothAccountFields++;
          }
          else if (field === 'cardNumber') {
            isAccountNumber = true;
            checkAccountNumber = filterValue[field].v1;
            checkBothAccountFields++;
          }
          else if(field === 'transactionAmount'){
            filterValue[field].v1 !== '' && filterValue[field].v1 !== undefined ? resultString = `${resultString}fromTransactionAmount=${filterValue[field].v1}&` : '';
            filterValue[field].v2 !== '' && filterValue[field].v2 !== undefined ? resultString = `${resultString}toTransactionAmount=${filterValue[field].v2}&` : '';
            checkBothAccountFields++;
          }
          else {
            resultString = `${resultString}${field}=${filterValue[field].v1}&`;
            checkBothAccountFields++;
          }
        }
      }

    });
    this.setState({ currentValues: newFilterValues });
      isAccountNumber == true ? this.getTokenFromCardNumber(checkAccountNumber, resultString) : this.postApplyFilterValues(resultString);
    }
  }

  mapActiveFilters(filters = [], data = []) {
    const results = [];
    filters.forEach((filter) => {
        const matchingFilter = data.find((column) => (column.reportFilterId) === (filter.id));
        if (matchingFilter &&
            matchingFilter.name) {
            results.push(
                Object.assign({}, filter, {
                    name: matchingFilter.name,
                    value: !filter.v2 ? filter.v1 : null,
                    values: filter.v2 ? { v1: filter.v1, v2: filter.v2 } : null,
                    v1: filter.v1,
                    v2: filter.v2,
                }),
            );
        }
    });
    return results;
}

  getTokenFromCardNumber(cardNumber, resultString) {
    return getToken(cardNumber)
      .then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState({
            isLoading: false,
          })
          resultString += `globalToken=${apiResponse.data.GlobalToken}&`;
          this.postApplyFilterValues(resultString);
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.log('Error Occured while tokenizing Card Number', error);
      });
  }

  postApplyFilterValues(resultString) {
    this.setState({
      isLoading: true,
      suggestedTransList: [],
      suggestedTransError: false,
      emptyStateTitle: counterpart('globalTranslate.queues.emptyStateHeading')
    })
    return postFilterValues(resultString)
      .then((apiResponse) => {
        this.setState({
          suggestedTransList: apiResponse.data,
          suggestedTransError: false,
          isLoading: false,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          suggestedTransList: [],
          suggestedTransError: true,
        });
        console.log('Error Occured while fetching details', error);
      });
  }

  /**
   * Fetch multiple transaction for the given case number.
   * @param {1234567890} caseNumber 
   */
  fetchMultipleMatchTransactionByCaseNumber(caseNumber) {
    fetchMultipleMatchTransactionByCaseNumber(caseNumber).then((apiResponse) => {
      this.setState({
        suggestedTransList: apiResponse.data,
        suggestedTransError: false,
      });
    })
      .catch((error) => {
        this.setState({
          suggestedTransList: [],
        });
      });
  }
  closeFilterPane = () => {
    this.setState({ filterPaneIsVisible: false });
  };

  resetFilterValues() {
    this.setState({
      currentValues: [],
    });
  }

  toggleFilterPane = () => {
    document.body.classList.add('instant-header');

    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    this.setState(
      {
        filterPaneIsVisible: !this.state.filterPaneIsVisible,
      },
    );
  };

  toggleTransactionManual() {
    this.setState({ showAddTransactionManual: !this.state.showAddTransactionManual });
  }
  openManualSearch() {
    this.setState({ showManualSearch: !this.state.showManualSearch });
  }
  getTransactionDetails(transactionDetail, unmatchedCaseDetail) {
    return {
      matchTransWithUnmatchedCase: {
        transactionDetail,
        unmatchedCaseDetail,
      },
    };
  }
  onClickPrimaryActionButton(transactionList) {
    const transactionDetail = Object.assign({}, transactionList);
    for (let i = 0; i < this.state.structureMetaData.dataColumns.length; i++) {
      if (this.state.structureMetaData.dataColumns[i] && transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey] &&
        this.state.structureMetaData.dataColumns[i].inputType == 'Date'
      ) {
        if (transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey]) {
          const date = moment(transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey]);
          transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey] = date.format(this.state.structureMetaData.dateFormatForApi);
        }
      }
      if (this.state.structureMetaData.dataColumns[i] && transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey] &&
        this.state.structureMetaData.dataColumns[i].inputType === 'DropDown'){
        if( transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey].value !== undefined) {
          transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey] = transactionDetail[this.state.structureMetaData.dataColumns[i].columnKey].value;
        }
      }
    }
    if (!transactionDetail.acqReferenceNumber && transactionDetail.arn) {
        transactionDetail.acqReferenceNumber = transactionDetail.arn;
    }

    transactionDetail.transactionAmount = transactionDetail.transactionAmount.value !== undefined ? transactionDetail.transactionAmount.value : transactionDetail.transactionAmount;
    if (transactionDetail.globalToken == undefined && this.state.caseData && "HPY" === this.state.caseData.acquirerName) {
      transactionDetail.globalToken = this.state.caseData.globalToken;
    }

    this.setState({
      addingNewTransaction: true,
    })
      addNewTransaction(
        this.getTransactionDetails(
          transactionDetail,
          this.state.caseData,
        ),
      ).then((res) => {
        const statusCode = res.status.statusCode;
        if (statusCode == 1001) {
          this.props.setNotification([{
            title: counterpart('globalTranslate.takeAction.tranAttached'),
            titleStyle: "color: 'light-green'",
            description: 'Transaction has been successfully attached to Case # ',
            descriptionStyle: "color: 'grey'",
            type: 'success',
            cancel: true,
            cancelButtonText: counterpart('globalTranslate.takeAction.dismiss'),
            secondaryButtonText: 'COPIED TO CLIPBOARD',
            primaryButtonText: 'COPY CASE NUMBER',
            isSecondaryButton: counterpart('globalTranslate.takeAction.dismiss'),
            isSecondaryButtonActive: true,
            primaryButtonActionValue: this.props.match.params.caseNumber,
            valueStyle: "color: 'black'",
            closeNotification: () => this.props.closeNotification(),
          }]);
          this.props.location.pathname.includes('/casestage/') ?
            this.props.history.push({
              pathname: `/queue/${AMEX_QUEUE}`,
            })
            : this.goBack();
        } else if (statusCode == 1002) {
          this.setState({
            isError: true,
            errorMessage: 'Unable to attach this transaction !',
          });
        } else if (statusCode == 1003) {
          this.setState({
            isError: true,
            errorMessage: 'This Transaction is already attached to the case !',
          });
        } else if (statusCode == 1004) {
          this.props.setNotification([{
            title: 'Not a DiMS Case Number',
            description: 'Do you want to delete this case?',
            descriptionStyle: "color: 'grey'",
            type: 'warning',
            cancel: true,
            cancelButtonText: 'NO',
            valueStyle: "color: 'black'",
            primaryButtonText: 'YES',
            primaryButtonAction: /* this.props.location.state ? this.props.location.state.deleteCase : */ this.deleteCase,
            primaryButtonActionValue: this.props.match.params.caseNumber,
            refreshData: "true",
            closeNotification: this.redirectToQueueLanding,
          }]);
        }
        this.setState({
          addingNewTransaction: false,
        })
      }).catch((res) => {
        this.setState({
          isError: true,
          addingNewTransaction: false,
          errorMessage: res.status && res.status.statusMsg,
        });
      });
  }

  closeBanner() {
    this.setState({
      isError: false,
      isMinField: true,
    });
  }

  redirectToQueueLanding() {
    this.props.closeNotification();
    this.props.location.pathname.includes('/casestage/')   ?
    this.props.history.push({
      pathname:`/queue/${_AMEX_QUEUE_}`,
    })
    :
    this.goBack();
  }

  goToCaseLandingPage() {
    if (this.state.caseData !== undefined) {
      this.props.history.push({
        state: {
          data: this.state.caseData,
          prevPath: `/queue/${this.props.match.params.queueId}`,
        },
        pathname: `/caselanding/${this.props.match.params.caseNumber}`,
      });
    }
  }

  handleTakeActionClick(key) {
    key === 'ADD_MANUALLY' && !this.state.showAddTransactionManual && this.toggleTransactionManual();
    key === 'ISSUER_FORWARD' && this.goToCaseLandingPage();
  }
  deleteCase(caseNumber) {
    this.setState({isLoading: true})
    this.props.closeNotification();
    return deleteNonDimsCase(this.props.match.params.caseNumber)
      .then((apiResponse) => {
        const statusCode = apiResponse.status.statusCode;
        if (statusCode === 2000) {
          this.setState({isLoading: false,})
          this.props.setNotification([{
            title: 'Case Deleted Successfully',
            titleStyle: "color: 'light-green'",
            description: 'The Case Has Been Deleted Successfully',
            descriptionStyle: "color: 'grey'",
            type: 'success',
            cancel: true,
            cancelButtonText: 'DISMISS',
            primaryButtonText: 'OK',
            primaryButtonAction: () => this.props.closeNotification(),
            valueStyle: "color: 'black'",
            refreshData: "false",
            closeNotification: () => this.props.closeNotification(),
          }]);
          this.props.location.pathname.includes('/casestage/')   ?
          this.props.history.push({
            pathname:`/queue/${_AMEX_QUEUE_}`,
          })
          :
            this.goBack();
          }
      })
      .catch((error) => {
        this.props.setNotification([{
          title: 'Error Occurred',
          description: 'Error Occurred While Deleting The Case',
          type: 'danger',
          cancelButtonText: 'DISMISS',
          primaryButtonText: 'OKAY, DO SOMETHING TO FIX IT',
          primaryButtonAction: this.props.closeNotification,
          closeNotification: () => this.props.closeNotification(),
          refreshData: "false",
        }]);
      });
  }
  showErrorBanner() {
    if (this.state.isError) {
      return (
        <div>
         <ImagePortal>
          <ResponseBanner
            titleStyle={{ color: 'light-green' }}
            descriptionStyle={{ color: 'grey' }}
            valueStyle={{ color: 'black' }}
            title={counterpart('globalTranslate.takeAction.errorOccurred')}
            description={this.state.errorMessage}
            type="danger"
            onClose={this.closeBanner}
            cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
            primaryButtonActionValue=""
            primaryButtonText={counterpart('globalTranslate.takeAction.okayDoSomething')}
            primaryButtonAction={this.closeBanner}
          />
          </ImagePortal>
        </div>
      );
    }
  }

  renderHorizontalTransactionSummaryPanel() {
    return (<div className="summaryhorizontalpanel">
      {!this.state.suggestedTransError && (this.state.isLoading || this.state.addingNewTransaction) && <BVLoader20 />}
      {
        this.state.suggestedTransError && !this.state.isLoading && (
          <EmptyState
            translations={{ emptyStateHeading: this.state.emptyStateTitle, emptyStateDescription: this.state.emptyStateMessage }}
          />
        )
      }
      {!this.state.addingNewTransaction && visibilityProps.isHorizontalPanel && (
        <GDTableSummaryHorizontalPanel
          type={visibilityProps.queueId}
          title={'Suggested Transactions'}
          summaryFields={visibilityProps.caseSelectionConfig.summaryHorizontalPanel.summaryColumns}
          summaryContent={this.state.suggestedTransList}
          actionMethod={this.onClickPrimaryActionButton}
          dateFormat={visibilityProps.caseSelectionConfig.page.dateFormat}
          isReadOnly={this.state.isReadOnly}
          user={this.props.user}
        />
      )}
      {!this.state.addingNewTransaction && visibilityProps.isManualTransaction && this.state.showAddTransactionManual && this.state.caseData && (
        <ManualTransaction
          onClickCancelButton={this.toggleTransactionManual}
          onClickPrimaryActionButton={this.onClickPrimaryActionButton}
          caseData={this.state.caseData}
          showErrorBanner={this.showErrorBanner()}
          structureMetaData={this.state.structureMetaData}
        />
      )
      }
      {visibilityProps.isHorizontalPanel && !this.state.showAddTransactionManual && (this.renderTransactionComponent())}
    </div>);
  }

  renderTransactionComponent() {
    return (<div className="comboButton">
      <span style={{ padding: 10, paddingRight: 60 }}><h2><b>Don't see your missing transaction?</b></h2></span>
      {this.state.isReadOnly ?
        <ComboButton
          firstButtonText="Manual Search"
          firstButtonType="hollow"
          secondButtonText="Add Transaction"
          secondButtonType="hollow"
          isDisabled={this.state.isReadOnly}
          user={this.props.user}
        /> :
        <ComboButton
          firstButtonText="Manual Search"
          firstButtonType="hollow"
          firstActionMethod={this.toggleFilterPane}
          secondButtonText="Add Transaction"
          secondButtonType="hollow"
          secondActionMethod={this.toggleTransactionManual}
          user={this.props.user}
        />
      }
    </div>
    );
  }

  getAllCasesData(queueId, pageNumber, paginatedRecords, sort, appliedFilters, regionCode, caseNumber, caseStageId) {
    this.setState({
      isLoading: true,
    });
    return getAllUnmatchedCases(queueId, pageNumber, paginatedRecords, sort, appliedFilters, regionCode,null,caseNumber, caseStageId)
      .then((apiResponse) => {
        const formattedData = this.getFormattedData(queueId, apiResponse);
        if (queueId == VITE_TRANSACTION_UNMATCHED_QUEUE) {
          postLockCase(caseNumber, caseStageId)
            .then((lockApiResponse) => {
              setLockedCaseCount(lockApiResponse.data.lockedCaseCount);
              if (lockApiResponse.data.isCaseLocked === true) {
                const notificationContent = <div style={{ color: 'black' }}>
                  <b>Read Only Mode.</b>
                  <p>This case is currently being worked by {lockApiResponse.data.userName}</p>
                </div>
                this.onReadOnly(notificationContent);
              }
              this.setState({
                caseData: formattedData[0],
                caseDataErr: false,
                isLoading: false,
                userName: lockApiResponse.data.userName,
                isReadOnly: lockApiResponse.data.isCaseLocked,
              }, () => {
                const caseStageId = getCaseStageId();
                this.prepopulateFilterValues(this.state.caseData);
                if (!lockApiResponse.data.isCaseLocked) {
                  setLockedCases(this.props.match.params.caseNumber, caseStageId);
                }
              });
            })
            .catch((error) => {
              this.setState({ caseDataErr: true, isLoading: false, emptyStateTitle: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateMessage: counterpart('globalTranslate.queues.emptyStateDescription') });
              if (error.response.status === 412) {
                this.setState({
                  emptyStateTitle: 'Maximum Tab Limit Reached!',
                  emptyStateMessage: 'You cannot work on more than 10 Cases at once!',

                });
              }
              console.log('Error Occured while fetching locking case', error);
            });
        } else {
          this.setState({
            caseData: formattedData[0],
            caseDataErr: false,
            isLoading: false,
          }, () => {
            this.prepopulateFilterValues(this.state.caseData);
          });
        }
      })
      .catch((error) => {
        this.setState({
          caseDataErr: true, isLoading: false,
          emptyStateTitle: counterpart('globalTranslate.queues.emptyStateHeading'),
          emptyStateMessage: counterpart('globalTranslate.queues.emptyStateDescription')
        });
        console.log('Error Occured while fetching unmatched case details', error);

      });

  }
  onReadOnly(notificationContent) {
    const notificationMessageSuccess = {
      type: 'info',
      placement: 'topRight',
      messageWidth: 250,
      byDefault: true,
      duration: 10,
      content: notificationContent,
    };

    return openNotificationToast(notificationMessageSuccess);

  }
  getFormattedData(queueId, apiResponse) {
    let formattedData;
    switch (queueId) {
      case '6':
        formattedData = apiResponse.data.content.map((row) => {
          return Object.assign(row.caseStageDetail, row.unmatchedCaseDetailModel, row.transactionDetail);
        });
        break;
      case '8':
        formattedData = apiResponse.data.content.map((row) => {
          return Object.assign(row.caseDetail, row.caseStageDetail, row.transactionDetail);
        });
        break;
    }
    return formattedData;
  }

  prepopulateFilterValues(caseData) {
    const structure = [].concat(visibilityProps);
    const filterList = visibilityProps.caseSelectionConfig.searchFilters;
    let newValue;
    const newValues = [];
    const updatedCaseData = { ...caseData };
    updatedCaseData.acquirerCode = updatedCaseData.acquirerName;
    delete updatedCaseData.acquirerName;
    filterList.map((filter) => {
      let data;
      data = updatedCaseData[`${filter.columnKey}`];
      newValue = Object.assign({}, {
        [filter.reportFilterId]: { v1: data, v2: data, id: filter.reportFilterId },
      });
      newValues.push(newValue);
    });
    newValues.forEach((filterValue) => {
      for (const field in filterValue) {
        if (filterValue[field] !== '' && filterValue[field].v1 !== '' && filterValue[field].v1 && field == 'cardNumberRk') {
          let maskedNumber = filterValue[field].v1.split(/(X)/ig || /(x)/ig);
          let lastVal = maskedNumber.length;
          filterValue[field].v1 = maskedNumber[0];
          filterValue[field].v2 = maskedNumber[lastVal - 1];
        }
        if (filterValue[field] !== '' && filterValue[field].v1 !== '' && field == 'transactionAmount') {
          filterValue[field].v1 = (Math.round(filterValue[field].v1 * 100) / 100).toFixed(2);
          filterValue[field].v2 = (Math.round(filterValue[field].v1 * 100) / 100).toFixed(2);
        }
        if (filterValue[field] && filterValue[field].v1  && field == 'transactionDate') {
          filterValue[field].v1 = moment(filterValue[field].v1).format(visibilityProps.caseSelectionConfig.page.dateFormat);
          filterValue[field].v2 = moment(filterValue[field].v1).format(visibilityProps.caseSelectionConfig.page.dateFormat);
        }
        if (filterValue[field] && filterValue[field].v1  && field == 'acquirerCode') {
          filterValue[field].v1 =caseData.acquirerName;
          filterValue[field].v2 = caseData.acquirerName;
        }
      }
    })

    this.setState({
      currentValues: newValues,
    });
  }
  unlockCurrentCase() {
    const caseStageId = getCaseStageId();
    return unlockCase(this.props.match.params.caseNumber, caseStageId)
      .then((apiResponse) => {
        let tabNumber = getLockedCaseCount();
        tabNumber--;
        setLockedCaseCount(tabNumber);
        this.setState({
          isReadOnly: apiResponse.data,
        });
      })
      .catch((error) => {
        console.log('Error Occured while Un-locking the case', error);
      });
  }

  removeCurrentLockedCase() {
    if (this.props.isUserAuthenticated && this.props.match.params.queueId == VITE_TRANSACTION_UNMATCHED_QUEUE) {
      const caseStageId = getCaseStageId();
      removeLockedCases(this.props.match.params.caseNumber, caseStageId);
    }
  }

  addFilterValidations(){
    const filterElements = visibilityProps.caseSelectionConfig.searchFilters.map((filter) => {
      return Object.assign(filter, {
          validations: getValidations(filter.filterType) != undefined ? getValidations(filter.filterType).validations : [],
          id: filter.reportFilterId,
        });
     });
     this.setState({
      filters: filterElements,
     });
  }

  render() {
    window.document.title = 'Case Selection';
    let wrapperClass;
    let actions;
    let filterPaneTriggerClasses;
    actions = visibilityProps.caseSelectionConfig.caseSelectionActions;
    filterPaneTriggerClasses = classnames('filter-pane-trigger', {
      'is-disabled': false,
    });

    return (
      <div className="case-selection"> <div style={{ width: '100%' }}>
        {this.showErrorBanner()}
        {!this.state.caseDataErr && this.state.isLoading && <BVLoader20 />}
        {
          this.state.caseDataErr && !this.state.isLoading && (<div className="data-unavailable">
            <EmptyState
              translations={{ emptyStateHeading: this.state.emptyStateTitle, emptyStateDescription: this.state.emptyStateMessage }}
            /></div>)
        }
        <div className={wrapperClass}>
          <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : 'main-content--header reports-container--header'} style={{ zIndex: 2 }}>
            <div className="flex-left">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {this.state.isReadOnly === true && <InformationBubble
                  tooltipContent={"Read Only Mode "}
                >
                  <UserLockIcon className="lockIcon" color="black" height="20px" width="15px" />
                </InformationBubble>
                }
                <h1 className="gd-report-runner__group-name">
                  {visibilityProps.caseSelectionConfig.page.reportName}
                </h1>
              </div>
            </div>
            {visibilityProps.isFilterPane &&
              <div className="flex-right" style={{ paddingRight: 13 }}>
                <div
                  role="button"
                  tabIndex={0}
                  id={`${visibilityProps.caseSelectionConfig.page.reportName}_filter_btn`}
                  className={filterPaneTriggerClasses}
                  disabled={false}
                  onClick={this.toggleFilterPane}
                  aria-expanded={this.state.filterPaneIsVisible}
                >
                  <span className="gd-report-runner__filter-toggle">
                    Search Transactions
                  </span>
                </div>
              </div>
            }
          </div>
          <div className={this.state.filterPaneIsVisible && this.props.isSearchActive ? '' : 'main-content--wrapper'}>
            {this.state.filterPaneIsVisible && visibilityProps.isFilterPane && this.state.caseData && (
              <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
                <GDFilterPane
                  applyFilters={this.handleApplyFilters}
                  closeFilterPane={this.closeFilterPane}
                  currentValues={this.state.currentValues}
                  dateFormat={visibilityProps.caseSelectionConfig.page.dateFormat}
                  filterList={this.state.filters}
                  isVisible={this.state.filterPaneIsVisible}
                  reportName={`${visibilityProps.caseSelectionConfig.page.reportName}_filterPane`}
                  data={this.state.caseData}
                  resetValues={this.resetFilterValues}
                  translations={getTranslations()}
                />
              </div>
            )}
          </div>
          <div className="case-selection-content">


            <div className="summarybar">
              {visibilityProps.isSummaryRow && this.state.caseData &&
                <GDTableSummaryRow
                  title={'Summary'}
                  summaryColumns={visibilityProps.caseSelectionConfig.summaryHeader.summaryColumns}
                  summaryData={[].concat(this.state.caseData)}
                  id={'transaction'}
                  isCaseSelection
                  actionButtonText={visibilityProps.caseSelectionConfig.page.actionButtonText}
                  rowActionClick={this.handleTakeActionClick}
                  actions={actions}
                  extraWidth
                  dateFormat={visibilityProps.caseSelectionConfig.page.dateFormat}
                  isReadOnly={this.state.isReadOnly}

                />
              }
            </div>

          </div>
          <div className="summarydisplay">
            <div className={(visibilityProps.isSummaryPanel && visibilityProps.isHorizontalPanel) == false ? 'summarypanelmax' : 'summarypanel'}>
              {this.state.caseData && <GDTableSummaryPanel
                title={'Summary'}
                dateFormat={visibilityProps.caseSelectionConfig.page.dateFormat}
                summaryColumns={visibilityProps.caseSelectionConfig.summaryPanel.summaryColumns}
                summaryContent={this.state.caseData}
                isToggle={visibilityProps.isToggle}
                isReadOnly={this.state.isReadOnly}
              />
              }
            </div>

            {this.renderHorizontalTransactionSummaryPanel()}
            {this.state.isMinField == false &&
            <ImagePortal>
              <ResponseBanner
                cancelOnly={true}
                titleStyle={{ color: 'light-green' }}
                descriptionStyle={{ color: 'grey' }}
                valueStyle={{ color: 'black' }}
                title={counterpart('globalTranslate.takeAction.validationError')}
                description={this.state.bannerDescription}
                type="danger"
                onClose={this.closeBanner}
                cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
              />
              </ImagePortal>
            }

          </div>
        </div>
      </div></div>
    );

  }

  getMerchantPaymentCurrency() {
    let index = -1;
    let currencyIndex = -1;
    let currencyCodes = [];
    getCurrencyBasedOnElementIdWithAcquirer('cq_dispute_currency', getAcquirerAccessList())
      .then((response) => {
        if (response.status.statusCode === 2000) {
          const updatedMetaData = { ...this.state.structureMetaData };
          updatedMetaData.dataColumns.forEach((dataColumn) => {
            index++;
            if (dataColumn.columnKey === 'paymentCurrencyAlpha') {
              currencyIndex = index;
              response.data.forEach((currencyCode) => {
                let currencyObject = {
                  text: currencyCode.currencyCode,
                  value: currencyCode.currencyCode,
                };
                currencyCodes.push(currencyObject);
              });
            }
          });
          if (currencyIndex != -1) {
            updatedMetaData.dataColumns[currencyIndex].list = currencyCodes;
            this.setState({ structureMetaData: updatedMetaData });
          }
        }
      })
  }

}


CaseSelection.propTypes = {
  extraClass: PropTypes.string,

};

CaseSelection.defaultProps = {
  extraClass: 'some-class',
};

const mapStateToProps = (state) => ({
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
  isUserAuthenticated: isUserAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setNotification: (banner) => dispatch(addManualTransactionNotificationBanner(banner)),
    setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    addCaseToRecentAction: (caseNumberToAdd) => {
      dispatch(addCaseToRecent(caseNumberToAdd));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseSelection);
